var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inertia-link',{attrs:{"href":_vm.route(_vm.routeLink)}},[_c('div',[_c('h2',{staticClass:"font-semibold text-xl leading-tight",class:_vm.getClassMenu( _vm.routeLink)},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }